import { ClockIcon, FunnelIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import AddButton from "../../../../../components/AddButton";
import {
  pdfData,
  isLoadingState,
  isAddState,
  getDataById,
  pdfFileState,
  isEditState,
  isAddInvoice,
  addFromVoidedState,
  officeVendorOptsData,
  isFromRediInvoice,
  invoiceDescription,
  pendingData,
  voidedData,
} from "../atoms/atoms";
import { InvoiceForm } from "../forms/InvoiceForm";
import Modal from "../../../../../components/Modal";
import SubmitHookForm from "../../../../../components/SubmitHookForm";
import CancelButton from "../../../../../components/CancelButton";
import { getPdf } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";
import ConfirmBoxModal from "../../../../../components/ConfirmBoxModal";
import { useAddInvoice } from "../hooks/useAddInvoice";
import { toast } from "../../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import { useGetInvoiceById } from "../hooks/useGetInvoiceById";
import PendingTableFilters from "./TableFilter";
import MaterialInvoiceTable from "../../../../../components/tables/MaterialInvoiceTable";
import { PERMISSIONS } from "../../../../PermissionsConstants";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { useGetOfficeVendors } from "../hooks/useGetOfficeVendors";
import { useLocation } from "react-router-dom";
import { useGetActivityHistoryById } from "../hooks/useGetActivityHistoryId";
import { IItemize } from "../types";
import { useGetPendingInvoices } from "../hooks/useGetPendingInvoices";
import { useGetPendingInvoiceById } from "../hooks/useGetPendingInvoiceById";
import { useGetVoidedInvoiceById } from "../hooks/useGetVoidedInvoiceById";
import axios from "axios";

interface Props {}

export const InvoiceCaptureTable: React.FC<Props> = () => {
  const [isShowInvoice, setShowInvoice] = useState(false);
  const [invoiceTableData, setInvoiceTableData] = useState<any[]>([]);
  const [showUploadModal, setShowUploadModal] = useRecoilState(isAddInvoice);
  const [invoiceByIdData, setGetInvoiceByIdData] =
    useRecoilState<any>(getDataById);
  const [rowForEdit, setRowForEdit] = useState();
  const [openConfirm, setOpenConfirm] = useState(false);

  const [pdfFile, setPdfFile] = useRecoilState<any>(pdfFileState);
  const [, setViewPdf] = useRecoilState<any>(pdfData);
  const [attachment, setAttachment] = useState<File | null>();
  const [, setIsLoading] = useRecoilState(isLoadingState);
  const [, setIsAdd] = useRecoilState(isAddState);
  const [, setEditState] = useRecoilState(isEditState);
  const queryClient = useQueryClient();
  const [filter, setFilter] = useState(false);
  const [filteredPending, setFilteredPending] = useState<any>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [addFromVoided, setAddFromVoided] =
    useRecoilState<any>(addFromVoidedState);
  const [officeVendorOpts, setOfficeVendorOpts] =
    useRecoilState<any>(officeVendorOptsData);
  const [isFromRedirection, setIsFromRedirection] =
    useRecoilState(isFromRediInvoice);
  const [, setDescriptionData] = useRecoilState(invoiceDescription);

  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadResult, setUploadResult] = useState<any>(null);
  const api_base_url = process.env.REACT_APP_API_BASEURL;

  const addPermission = PERMISSIONS.permission_vendorinvoice_add;

  const userPermissions = useRecoilValue(permissionsSelector);
  const onClickCancelShow = () => {
    setAddFromVoided(false);
    setShowInvoice(false);
  };
  const [, setPendingInvoiceDetails] = useRecoilState(pendingData);
  const [, setVoidedInvoiceDetails] = useRecoilState(voidedData);
  //#region Handle PDF
  //set file upon click batch id
  const retrieveFile = async (fileName) => {
    try {
      setIsLoading(true);
      getPdf(fileName).then((content) => {
        const pdfBlob = new Blob([content.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setViewPdf(pdfUrl);
        setIsLoading(false);
        if (officeVendorOpts) {
          setShowInvoice(true);
        }
      });
    } catch (error) {}
  };

  //set file upon upload
  const fileType = ["application/pdf"];
  const handleChange = (e) => {
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (
        selectedFile &&
        fileType.includes(selectedFile.type) &&
        e.target.files.length > 0
      ) {
        const newFile = e.target.files ? e.target.files.item(0) : null;
        setAttachment(newFile);
        let reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = (e) => {
          setPdfFile(e?.target?.result);
        };
      } else {
        setPdfFile(null);
      }
    } else {
      setPdfFile(null);
    }
  };
  //#endregion
  //Single Add Initialization
  const {
    mutate: addVendorInvoice,
    isSuccess: addVendorInvoiceSuccess,
    data: addVendorInvoiceResult,
    reset: resetAddVendorInvoiceData,
  } = useAddInvoice();

  const handleSubmit = async () => {
    setOpenConfirm(false);
    setShowUploadModal(false);
    setIsAdd(false);
    if (pdfFile !== null) {
      setViewPdf(pdfFile);
      setUploading(true);
      setProgress(0);
      setUploadSuccess(false);
      setUploadResult(null);

      try {
        const invoiceData = {
          attachment: attachment,
        };
        const formData = new FormData();
        invoiceData.attachment &&
          formData.append("attachment", invoiceData.attachment);
        const response = await axios.post(
          `${api_base_url}/VendorInvoice`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgress(percentCompleted);
            },
          }
        );

        setUploadResult(response);
        setUploadSuccess(true);
      } catch (error) {
        toast.fire("Error", "Failed.", "error");
        setUploading(false);
      }
    } else {
      setViewPdf(null);
    }
  };

  const handleSave = () => {
    const VendorInvoiceData = {
      attachment: attachment,
    };
    addVendorInvoice(VendorInvoiceData);
  };

  //mutation
  const {
    data: invoiceDataEdit,
    mutate: getInvoiceById,
    isSuccess: getSuccess,
    reset: resetGetInvoice,
  } = useGetInvoiceById();

  const {
    data: pendingInvoiceData,
    mutate: getPendingInvoiceById,
    isSuccess: getPendingSuccess,
    reset: resetGetPendingInvoice,
  } = useGetPendingInvoiceById();

  if (getPendingSuccess && pendingInvoiceData) {
    if (
      pendingInvoiceData?.status === 201 ||
      pendingInvoiceData?.status === 200
    ) {
      setPendingInvoiceDetails(pendingInvoiceData.data);
    }
    resetGetPendingInvoice();
  }

  const {
    data: voidedInvoiceData,
    mutate: getVoidedInvoiceById,
    isSuccess: getVoidedSuccess,
    reset: resetGetVoidedInvoice,
  } = useGetVoidedInvoiceById();

  if (getVoidedSuccess && voidedInvoiceData) {
    if (
      voidedInvoiceData?.status === 201 ||
      voidedInvoiceData?.status === 200
    ) {
      setVoidedInvoiceDetails(voidedInvoiceData.data);
    }
    resetGetVoidedInvoice();
  }

  const {
    data: invoiceData,
    isFetching: vendorInvoiceFetching,
    isSuccess: getVendorInvoiceSuccess,
  } = useGetPendingInvoices();
  useEffect(() => {
    if (getVendorInvoiceSuccess && invoiceData) {
      setInvoiceTableData(invoiceData?.data);
    }
  }, [invoiceData]);

  // View data from recent act
  let location = useLocation();

  let recordIdFromRecent;
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (
      recordIdFromRecent?.moduleName === "Vendor Invoice" &&
      invoiceTableData?.length > 0 &&
      isFromRedirection
    ) {
      const filteredData = invoiceTableData?.filter(
        (x) => x.vendorInvoiceId === Number(recordIdFromRecent.recordId)
      )[0];
      const itemizesList = [] as Array<IItemize>;
      if (
        filteredData?.itemizeDetails &&
        filteredData?.itemizeDetails?.length > 0
      ) {
        filteredData?.itemizeDetails.forEach((obj: IItemize, index: number) => {
          const reportsData = {
            ...obj,
            isActive: true,
            parentRow: index > 0 ? false : true,
            tableName: "itemizeDetails",
          };
          itemizesList.push(reportsData);
        });
      }
      const description = getDescription(filteredData);
      setDescriptionData({
        AccountNumber: filteredData?.accountNumber,
        BankAccount: filteredData?.bankAccount,
        BillDueDate: filteredData?.billingPeriodEndDate,
        ServiceDueDate: filteredData?.servicePeriodDate,
        DueDate: filteredData?.duedate,
        AutoPay: filteredData?.autoPayName,
      });
      setRowForEdit({
        ...filteredData,
        description: description,
        itemizeDetails: itemizesList,
        amountPaid:
          filteredData?.amountPaid === 0 ? undefined : filteredData?.amountPaid,
        vendorBankAccount: filteredData?.vendorBankAccount
          ? filteredData?.vendorBankAccount?.replace(/.(?=.{4})/g, "x")
          : null,
        servicePeriodDate: filteredData?.servicePeriodDate
          ? filteredData?.servicePeriodDate?.slice(0, 10)
          : null,
        billingPeriodEndDate: filteredData?.billingPeriodEndDate
          ? filteredData?.billingPeriodEndDate?.slice(0, 10)
          : null,
        dateCapture: filteredData?.dateCapture
          ? filteredData?.dateCapture?.slice(0, 10)
          : null,
        duedate: filteredData?.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
        bankReferenceDate: filteredData?.bankReferenceDate
          ? filteredData?.bankReferenceDate?.slice(0, 10)
          : null,
        createdDate: filteredData?.createdDate
          ? filteredData?.createdDate?.slice(0, 10) +
            " " +
            new Date(filteredData?.createdDate).toLocaleTimeString(
              navigator.language,
              {
                hour: "2-digit",
                minute: "2-digit",
              }
            )
          : null,
        modifiedDate: filteredData?.modifiedDate
          ? filteredData?.modifiedDate?.slice(0, 10) +
            " " +
            new Date(filteredData?.modifiedDate).toLocaleTimeString(
              navigator.language,
              {
                hour: "2-digit",
                minute: "2-digit",
              }
            )
          : null,
      });
      retrieveFile(filteredData?.invoiceImageAttachment);
      const id = { Id: filteredData?.id };
      getPendingInvoiceById(id);
      getVoidedInvoiceById(id);
      getactivityHistoryById(filteredData?.id);
      setShowInvoice(true);
      setIsFromRedirection(false);
    }
  }, [recordIdFromRecent, invoiceTableData]);

  const { data: activityHistoryData, mutate: getactivityHistoryById } =
    useGetActivityHistoryById();

  const getMaskedBankAccount = (
    bankAccount: string | undefined
  ): string | null => {
    return bankAccount ? bankAccount.replace(/.(?=.{4})/g, "x") : "N/A";
  };
  function formatDate(date) {
    if (!date) {
      return "N/A";
    }
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }
  const getDescription = (rowData): string => {
    if (rowData?.length === 0) {
      return "Account#: N/A DUE N/A; Service N/A to N/A";
    }
    const autoPayDescription = rowData?.autoPayName
      ? rowData?.autoPayName?.toLowerCase() === "eft"
        ? getMaskedBankAccount(rowData?.bankAccount)
        : `AUTOPAY ${getMaskedBankAccount(rowData?.bankAccount)}`
      : "";
    const accountNumber = rowData?.accountNumber
      ? rowData?.accountNumber
      : "N/A";
    return `Account#: ${accountNumber} ${autoPayDescription} DUE ${formatDate(
      rowData?.duedate
    )}; Service date ${formatDate(rowData?.servicePeriodDate)} to ${formatDate(
      rowData?.billingPeriodEndDate
    )} `;
  };
  const ClickViewDetails = (rowdata) => {
    const itemizes = [] as Array<IItemize>;
    const description = getDescription(rowdata);
    if (rowdata.itemizeDetails && rowdata.itemizeDetails?.length > 0) {
      const mappedItemized = rowdata?.itemizeDetails?.map((x, index) => {
        return {
          ...x,
          unitCost: x.unitCost?.toFixed(2),
          extCost: x.extCost?.toFixed(2),
          amount: x.amount?.toFixed(2),
          isActive: true,
          parentRow: index > 0 ? false : true,
          tableName: "itemizeDetails",
        };
      });
      itemizes.push(...mappedItemized);
    }
    setDescriptionData({
      AccountNumber: rowdata.accountNumber,
      BankAccount: rowdata.bankAccount,
      BillDueDate: rowdata?.billingPeriodEndDate,
      ServiceDueDate: rowdata?.servicePeriodDate,
      DueDate: rowdata?.duedate,
      AutoPay: rowdata?.autoPayName,
    });
    setRowForEdit({
      ...rowdata,
      description: description,
      itemizeDetails: itemizes,
      amountPaid: rowdata.amountPaid === 0 ? undefined : rowdata.amountPaid,
      vendorBankAccount: rowdata.vendorBankAccount
        ? rowdata.vendorBankAccount.replace(/.(?=.{4})/g, "x")
        : null,
      servicePeriodDate: rowdata.servicePeriodDate
        ? rowdata.servicePeriodDate.slice(0, 10)
        : null,
      billingPeriodEndDate: rowdata.billingPeriodEndDate
        ? rowdata.billingPeriodEndDate.slice(0, 10)
        : null,
      dateCapture: rowdata.dateCapture
        ? rowdata.dateCapture.slice(0, 10)
        : null,
      duedate: rowdata.duedate ? rowdata.duedate.slice(0, 10) : null,
      bankReferenceDate: rowdata.bankReferenceDate
        ? rowdata.bankReferenceDate.slice(0, 10)
        : null,
      draftDate: rowdata.draftDate ? rowdata.draftDate.slice(0, 10) : null,
      previousBalanceAmount:
        rowdata.previousBalanceAmount === 0
          ? undefined
          : rowdata.previousBalanceAmount,
      createdDate: rowdata.createdDate
        ? rowdata?.createdDate.slice(0, 10) +
          " " +
          new Date(rowdata?.createdDate).toLocaleTimeString(
            navigator.language,
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          )
        : null,
      modifiedDate: rowdata.modifiedDate
        ? rowdata?.modifiedDate.slice(0, 10) +
          " " +
          new Date(rowdata?.modifiedDate).toLocaleTimeString(
            navigator.language,
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          )
        : null,
    });
  };

  const matColumns = [
    {
      title: "Batch Id",
      field: "id",
      render: (rowdata) => {
        return (
          <div
            className="blueAndBold underline cursor-pointer "
            onClick={() => {
              setEditState(false);
              ClickViewDetails(rowdata);
              retrieveFile(rowdata.invoiceImageAttachment);
              const id = { Id: rowdata?.id };
              getVoidedInvoiceById(id);
              getPendingInvoiceById(id);
              getactivityHistoryById(rowdata?.id);
            }}
          >
            {rowdata.id}
          </div>
        );
      },
    },
    {
      title: "Filename",
      field: "invoiceImageAttachment",
      render: (rowdata) => {
        return (
          <div className="truncate w-40">{rowdata.invoiceImageAttachment}</div>
        );
      },
    },
    {
      title: "Corporate Office No.",
      field: "storeNumber",
    },
    {
      title: "Bank Account",
      field: "",
      render: (rowdata) => {
        return rowdata.bankAccount
          ? rowdata.bankAccount.replace(/.(?=.{4})/g, "x")
          : null;
      },
    },
    {
      title: "Service Account No.",
      field: "accountNumber",
    },
    {
      title: "Date Created",
      field: "createdDate",
      render: (rowdata) => {
        return (
          <div>
            {rowdata.createdDate
              ? new Date(rowdata.createdDate).toLocaleDateString()
              : "unspecified"}
          </div>
        );
      },
    },
  ];

  const handleCancel = () => {
    setOpenConfirm(false);
    setPdfFile(null);
    setShowUploadModal(false);
    setIsAdd(true);
  };

  useEffect(() => {
    if (addFromVoided) {
      const itemizesList = [] as Array<IItemize>;
      if (
        invoiceByIdData?.itemizeDetails &&
        invoiceByIdData?.itemizeDetails?.length > 0
      ) {
        invoiceByIdData?.itemizeDetails.forEach(
          (obj: IItemize, index: number) => {
            const reportsData = {
              ...obj,
              isActive: true,
              parentRow: index > 0 ? false : true,
              tableName: "itemizeDetails",
            };
            itemizesList.push(reportsData);
          }
        );
      }
      const description = getDescription(invoiceByIdData);
      setDescriptionData({
        AccountNumber: invoiceByIdData?.accountNumber,
        BankAccount: invoiceByIdData?.bankAccount,
        BillDueDate: invoiceByIdData?.billingPeriodEndDate,
        ServiceDueDate: invoiceByIdData?.servicePeriodDate,
        DueDate: invoiceByIdData?.duedate,
        AutoPay: invoiceByIdData?.autoPayName,
      });
      setGetInvoiceByIdData({
        ...invoiceByIdData,
        description: description,
        itemizeDetails: itemizesList,
        amountPaid:
          invoiceByIdData.amountPaid === 0
            ? undefined
            : invoiceByIdData.amountPaid,
        bankAccount: invoiceByIdData.bankAccount
          ? invoiceByIdData.bankAccount.replace(/.(?=.{4})/g, "x")
          : null,
        servicePeriodDate: invoiceByIdData.servicePeriodDate
          ? invoiceByIdData.servicePeriodDate.slice(0, 10)
          : null,
        billingPeriodEndDate: invoiceByIdData.billingPeriodEndDate
          ? invoiceByIdData.billingPeriodEndDate.slice(0, 10)
          : null,
        dateCapture: invoiceByIdData.dateCapture
          ? invoiceByIdData.dateCapture.slice(0, 10)
          : null,
        duedate: invoiceByIdData.duedate
          ? invoiceByIdData.duedate.slice(0, 10)
          : null,
        bankReferenceDate: invoiceByIdData.bankReferenceDate
          ? invoiceByIdData.bankReferenceDate.slice(0, 10)
          : null,
        draftDate: invoiceByIdData.draftDate
          ? invoiceByIdData.draftDate.slice(0, 10)
          : null,
        previousBalanceAmount:
          invoiceByIdData.previousBalanceAmount === 0
            ? undefined
            : invoiceByIdData.previousBalanceAmount,
        createdDate: invoiceByIdData.createdDate
          ? invoiceByIdData?.createdDate.slice(0, 10) +
            " " +
            new Date(invoiceByIdData?.createdDate).toLocaleTimeString(
              navigator.language,
              {
                hour: "2-digit",
                minute: "2-digit",
              }
            )
          : null,
        modifiedDate: invoiceByIdData.modifiedDate
          ? invoiceByIdData?.modifiedDate.slice(0, 10) +
            " " +
            new Date(invoiceByIdData?.modifiedDate).toLocaleTimeString(
              navigator.language,
              {
                hour: "2-digit",
                minute: "2-digit",
              }
            )
          : null,
      });
      retrieveFile(invoiceByIdData?.invoiceImageAttachment);
      const id = { Id: invoiceByIdData?.id };
      getVoidedInvoiceById(id);
      getPendingInvoiceById(id);
      getactivityHistoryById(invoiceByIdData?.id);
    }
  }, [addFromVoided]);

  useEffect(() => {
    if (uploadSuccess && uploadResult) {
      if (uploadResult.status === 200 || uploadResult.status === 201) {
        toast.fire(
          "Success",
          "Vendor invoice has been added successfully",
          "success"
        );
        const getData = {
          Id: uploadResult?.data?.id,
        };
        getInvoiceById(getData);
        setIsAdd(true);
        queryClient.invalidateQueries("GetInvoices");
      }
      setUploading(false);
      setUploadSuccess(false);
      setUploadResult(null);
    }

    if (getSuccess && invoiceDataEdit) {
      if (invoiceDataEdit?.status === 201 || invoiceDataEdit?.status === 200) {
        const itemizesList = [] as Array<IItemize>;
        const dataForEdit = invoiceDataEdit?.data[0];
        dataForEdit?.itemizeDetails.forEach((obj: IItemize, index: number) => {
          const reportsData = {
            ...obj,
            isActive: true,
            parentRow: index > 0 ? false : true,
            tableName: "itemizeDetails",
          };
          itemizesList.push(reportsData);
        });
        setGetInvoiceByIdData({
          ...dataForEdit,
          itemizeDetails: itemizesList,
          amountPaid:
            dataForEdit.amountPaid === 0 ? undefined : dataForEdit.amountPaid,
          bankAccount: dataForEdit.bankAccount
            ? dataForEdit.bankAccount.replace(/.(?=.{4})/g, "x")
            : null,
          servicePeriodDate: dataForEdit.servicePeriodDate
            ? dataForEdit.servicePeriodDate.slice(0, 10)
            : null,
          billingPeriodEndDate: dataForEdit.billingPeriodEndDate
            ? dataForEdit.billingPeriodEndDate.slice(0, 10)
            : null,
          dateCapture: dataForEdit.dateCapture
            ? dataForEdit.dateCapture.slice(0, 10)
            : null,
          duedate: dataForEdit.duedate
            ? dataForEdit.duedate.slice(0, 10)
            : null,
          bankReferenceDate: dataForEdit.bankReferenceDate
            ? dataForEdit.bankReferenceDate.slice(0, 10)
            : null,
          draftDate: dataForEdit.draftDate
            ? dataForEdit.draftDate.slice(0, 10)
            : null,
          previousBalanceAmount:
            dataForEdit.previousBalanceAmount === 0
              ? undefined
              : dataForEdit.previousBalanceAmount,
          createdDate: dataForEdit.createdDate
            ? dataForEdit?.createdDate.slice(0, 10) +
              " " +
              new Date(dataForEdit?.createdDate).toLocaleTimeString(
                navigator.language,
                {
                  hour: "2-digit",
                  minute: "2-digit",
                }
              )
            : null,
          modifiedDate: dataForEdit.modifiedDate
            ? dataForEdit?.modifiedDate.slice(0, 10) +
              " " +
              new Date(dataForEdit?.modifiedDate).toLocaleTimeString(
                navigator.language,
                {
                  hour: "2-digit",
                  minute: "2-digit",
                }
              )
            : null,
        });
        setShowUploadModal(false);
        setShowInvoice(true);
      }
      resetGetInvoice();
    }
  }, [uploadResult, uploadSuccess, getSuccess]);

  const { data: officeVendorData } = useGetOfficeVendors();
  if (officeVendorData !== undefined) {
    setOfficeVendorOpts(officeVendorData);
  }
  return (
    <>
      {!isShowInvoice && (
        <div className="">
          <div className="flex gap-2 items-center py-2">
            <div>
              <ClockIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <h3 className="text-xs font-medium text-gray-500">
                Vendor Invoice Processing
              </h3>
              <h1 className="mr-auto font-bold text-primary text-md uppercase">
                Batch List
              </h1>
            </div>
          </div>
          <div className="text-xs  space-y-2">
            <div className="ml-auto flex justify-between pb-2 ">
              <div className="space-x-4 mr-6 ">
                <button
                  className="hover:scale-90 transition duration-500 focus:bg-primary focus:text-white flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
                  onClick={() => {
                    setFilter(!filter);
                  }}
                >
                  <div>Filter By</div>
                  <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                </button>
              </div>
              <div className="flex flex-col-2">
                {uploading && (
                  <div className="w-32 bg-gray-200 rounded-full h-6 mt-0.5 mr-2">
                    <div
                      className="bg-secondary h-6 rounded-full transition-all duration-300 flex items-center justify-center"
                      style={{ width: `${progress}%` }}
                    >
                      <span className="items-center text-white">
                        Uploading...
                      </span>
                    </div>
                  </div>
                )}

                {userPermissions.includes(addPermission) && (
                  <div>
                    <AddButton
                      className={"opacity-100"}
                      disabled={false}
                      buttonText="Add Invoice"
                      onClick={() => {
                        setShowUploadModal(true);
                        setIsAdd(true);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <main className="flex flex-row pt-2">
            {filter && (
              <div className="overflow-y-auto  flex-col flex-grow bg-white">
                <PendingTableFilters
                  data={invoiceTableData}
                  setFilteredPending={setFilteredPending}
                  setIsSearching={setIsSearching}
                />
              </div>
            )}
            <div
              className={
                !filter
                  ? "false w-full h-5/6 bg-white overflow-x-auto box-shadow  "
                  : "w-4/5 h-5/6 bg-white overflow-y-auto box-shadow"
              }
            >
              {!isShowInvoice && (
                <MaterialInvoiceTable
                  columns={matColumns}
                  data={isSearching ? filteredPending : invoiceTableData}
                  isLoading={vendorInvoiceFetching}
                />
              )}
            </div>
          </main>
        </div>
      )}
      {/* Upload file modal */}
      {showUploadModal && (
        <Modal
          isCloseHide={true}
          modalFilterStat=""
          className=""
          width={"w-100"}
          title={""}
          isOpen={showUploadModal}
          onClose={undefined}
          hasCloseButton={false}
        >
          <div className="container">
            <div className="flex justify-between">
              <div className="ml-2 font-bold text-primary text-md">
                {"Add Invoice"}
              </div>
              <div className="flex justify-between gap-2 mr-2">
                <SubmitHookForm
                  type="button"
                  disabled={false}
                  buttonText={"Save"}
                  className={undefined}
                  onClick={() => {
                    if (pdfFile === null) {
                      toast.fire(
                        "Information",
                        "Please upload pdf file to proceed.",
                        "info"
                      );
                      setIsAdd(true);
                    } else {
                      setOpenConfirm(true);
                    }
                  }}
                />
                <CancelButton
                  onClick={() => {
                    handleCancel();
                  }}
                />
              </div>
            </div>

            <input
              type="file"
              className="form-control"
              onChange={handleChange}
            />
          </div>
        </Modal>
      )}
      {/* Confirmation modal */}
      {openConfirm && (
        <ConfirmBoxModal
          ModalTitle={"Add Vendor Invoice"}
          qConfirmation={`Are you sure you want to upload this file?`}
          isOpen={openConfirm}
          onClose={() => setOpenConfirm(false)}
          onClickFunction={() => handleSubmit()}
          cancelButtonRef={undefined}
        />
      )}
      {isShowInvoice && (
        <InvoiceForm
          cancelShow={onClickCancelShow}
          rowForEdit={invoiceByIdData ? invoiceByIdData : rowForEdit}
          activityHistoryData={activityHistoryData}
        />
      )}
    </>
  );
};
